
const MainPageStyle = theme => ({
    wrapper: {
        display: "flex",
        flex: 1,
        position: "relative"
    },
    contentWrapper: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        overflow: "auto"
    },
    headerSection: {
        display: "flex",
        width: "100%",
        borderBottom: "1px solid #EDEDED"
    },
    headerToggleStyle: {
        paddingLeft: 43
    },
    demographics: {
        display: "flex",
        width: 276,
        minWidth: 276,
        height: "100%",
        flexDirection: "column",
        borderRight: "1px solid #EDEDED",
        alignItems: "center",
    },
    demographicsHistory: {
        display: "flex",
        width: 276,
        minWidth: 276,
        height: "100%",
        flexDirection: "column",
        borderRight: "1px solid #EDEDED",
        alignItems: "center",
        paddingBottom: 10
    },
    stats: {
        display: "flex",
        width: "100%",
        height: 60,
        borderBottom: "1px solid #EDEDED",
        alignItems: "center",
    },
    patientStats: {
        color: "rgba(77,77,77,0.57)",
        fontFamily: "Proxima Nova",
        fontSize: 20,
        letterSpacing: 0,
        lineHeight: "24px"
    },
    statsDetails: {
        display: "flex",
        flex: 1,
        justifyContent: "space-between",
        marginLeft: 40,
        alignItems: "center",
        marginRight: 23
    },
    statsDetailsHistory: {
        display: "flex",
        flex: 1,
        marginLeft: 23,
        alignItems: "center",
        marginRight: 23
    },
    statsButton: {
        display: "flex",
        width: "200px",
        marginLeft: 30,
        marginRight: 30
    },
    textCenter: {
        textAlign: "center"
    },
    textCenterHistory: {
        textAlign: "center",
        marginRight: 160
    },
    patientStatsTitle: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        letterSpacing: 0,
        lineHeight: "17px"
    },
    patientName: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 30,
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "32px",
        textAlign: "center",
        wordBreak: "break-all",
        marginTop: 36
    },
    patientDOBContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: 41
    },
    patientRegion: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 22,
        fontWeight: 300,
        letterSpacing: 0,
        lineHeight: "27px",
        textAlign: "center",
        marginTop: 4
    },
    patientGender: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 22,
        fontWeight: 300,
        letterSpacing: 0,
        lineHeight: "27px",
        textAlign: "center",
        marginTop: 4
    },
    storefrontName: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "17px",
        textAlign: "center",
        marginTop: 4,
        wordBreak: "break-all"
    },
    hyperlink: {
        display: "flex",
        justifyContent: "space-between",
    },
    statsWrapper: {
        display: "flex",
        flexDirection: "column",
        flex: 1
    },
    medWrapper: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        paddingTop: 16,
        paddingLeft: 40,
        paddingRight: 23,
        paddingBottom: 14
    },
    storefrontMedication: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 18,
        letterSpacing: 0,
        lineHeight: "18px",
        whiteSpace: "pre-wrap"
    },
    medBold: {
        fontWeight: "bold"
    },
    storefrontMedicationMargin: {
        marginTop: 13
    },
    actionWrapper: {
        marginTop: 13,
        display: "flex",
        width: "100%",
        height: 40,
    },
    actionParent: {
        display: "flex",
    },
    // medButton: {
    //     height: 40,
    //     width: 160,
    //     backgroundColor: "#1c4445",
    //     borderRadius: 3,
    //     display: "flex",
    //     justifyContent: "center",
    //     alignItems: "center",
    //     color: "white",
    //     fontFamily: "Proxima Nova",
    //     fontSize: 16,
    //     fontWeight: "bold",
    //     letterSpacing: 0,
    //     lineHeight: "20px",
    //     cursor: "pointer"
    // },

    medButton: {
        boxShadow: 'none',
        height: 40,
        marginRight: 15,
        width: 124,
        textTransform: 'none',
        fontSize: 16,
        lineHeight: "18px",
        padding: "0px 10px",
        fontWeight: "bold",
        backgroundColor: '#1c4445',
        fontFamily: "Proxima Nova",
        '&:hover': {
            backgroundColor: '#1c4445',
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: '#1c4445',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: '#1c4445',
            boxShadow: 'none',
        },
        '&:disabled': {
            color: 'white',
            boxShadow: 'none',
        }
    },
    medSmallButton: {
        width: "110px !important",
        marginRight: "13px !important",
        padding: "0px !important"
    },
    lastButton: {
        marginRight: "0px !important",
    },
    criticalNoteWrapper: {
        display: "flex",
        flexDirection: "column"
    },
    criticalNoteWrapperRow: {
        display: "flex",
        color: "red",
        paddingLeft: 34,
        textIndent: -17,
        paddingRight: 17,
        fontFamily: "Proxima Nova",
        fontSize: 14,
        letterSpacing: 0,
        lineHeight: "17px",
        minHeight: 21,
        alignItems: "center",
        paddingTop: 5,
        paddingBottom: 5
    },
    criticalNoteNotRequired: {
        color: "#242424"
    },
    criticalNoteWrapperEvenRow: {
        backgroundColor: "#fafafa"
    },
    tabHeader: {
        width: "100%",
        height: 50,
        minHeight: 50,
        maxHeight: 50,
        paddingTop: 10,
        paddingLeft: 20,
        backgroundColor: "#fafafa"
    },
    indicator: {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        '& > div': {
            maxWidth: 80,
            width: '100%',
            backgroundColor: '#4981c5',
        },
    },
    tabsRoot: {
        minHeight: 30,
    },
    tabStyle: {
        color: "black",
        fontFamily: "Proxima Nova",
        fontSize: "20px",
        letterSpacing: 0,
        lineHeight: "24px",
        padding: 0,
        minHeight: 30,
        minWidth: "80px",
        marginRight: 30,
        opacity: "1 !important",
        textTransform: "unset"
    },
    selectedTab: {
        color: "black",
        fontFamily: "Proxima Nova",
        fontSize: "20px",
        letterSpacing: 0,
        lineHeight: "24px",
        padding: 0,
        minHeight: 30,
        minWidth: "80px",
        fontWeight: "bold",
        marginRight: 30,
        opacity: "1 !important",
        textTransform: "unset"
    },




    /////

    consultWrapper: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
    },
    tableWrapper: {
        display: "flex",
        width: "100%",
        flexShrink: 0
    },
    questionsWrapper: {
        display: "flex",
        width: "100%",
        flexDirection: "column",
        position: "relative",
        overflow: "auto",

    },
    questionsProductWrapper: {
        display: "flex",
        width: "100%",
        flexDirection: "column",
        position: "relative",
    },
    questionsHeaderAndTitleWrapper: {
        display: "flex",
        width: "100%",
        flexDirection: "column",
        position: "relative"
    },
    questionsTitleWrapper: {
        display: "flex",
        width: "100%",
        backgroundColor: "#eef1f1",
        minHeight: 35,
        alignItems: "center"
    },
    consultationTitle: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "16px",
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        width: "70%",
        padding: "0px 20px"
    },
    consultationAnswerTitle: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "16px",
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        display: "flex",
        flex: 1,
        paddingRight: "20px"
    },
    questionsRowWrapper: {
        display: "flex",
        paddingTop: 6.5,
        paddingBottom: 6.5,
        alignItems: "center",
        width: "100%",
        borderBottom: "2px solid #ededed",
        backgroundColor: "#ffffff"
    },
    questionsRowWrapperOddRow: {
        display: "flex",
        paddingTop: 6.5,
        paddingBottom: 6.5,
        alignItems: "center",
        borderBottom: "2px solid #ededed",
        width: "100%",
        backgroundColor: "#fafafa"
    },
    tableRowWrapper: {
        display: "flex",
        marginTop: 13,
        flexDirection: "column"
    },
    tableHeaderTitle: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "16px",
        display: "flex",
        minHeight: 35,
        alignItems: "center",
        fontWeight: "bold",
        letterSpacing: "0",
        paddingLeft: 20,
        lineHeight: "20px",
        backgroundColor: "#eef1f1"
    },
    iconHeader: {
        paddingLeft: "0px !important",
        minWidth: 17,
        paddingRight: "0px !important"
    },
    tableRow: {
        display: "flex",
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        letterSpacing: "0",
        lineHeight: "24px",
        maxHeight: 24,
        paddingLeft: 20,
        marginBottom: 13
    },
    tableRowEllipsis: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "inline-block !important"
    },
    editIconWrapper: {
        display: "flex",
        flexDirection: "column"
    },
    tableCenter: {
        justifyContent: "center"
    },
    tableRowBold: {
        fontWeight: "bold"
    },
    orderDateStyle: {
        minWidth: 87,
        display: "flex",
        flexDirection: "column"
    },
    orderNumberStyle: {
        minWidth: 116,
        display: "flex",
        flexDirection: "column"
    },
    productStyle: {
        display: "flex",
        flex: 1,
        flexDirection: "column"
    },
    editIcon: {
        minHeight: 14,
        maxHeight: 14,
        minWidth: 14,
        maxWidth: 14,
        cursor: "pointer"
    },
    imageWrapper: {
        minHeight: 24,
        marginBottom: 13,
        display: "flex",
        alignItems: "center"
    },
    qty: {
        display: "flex",
        minWidth: 28,
        flexDirection: "column"
    },
    orderType: {
        display: "flex",
        flexDirection: "column"
    },
    status: {
        display: "flex",
        flexDirection: "column"
    },

    checkbox: {
        padding: 0,
        marginRight: 5,
        color: "#00c469 !important"
    },
    disabledCheckbox: {
        padding: 0,
        marginRight: 5,
        color: "grey !important"
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalBody: {
        height: 407,
        width: 568,
        border: "1px solid #979797",
        borderRadius: 5,
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        outline: "none",
        overflow: "hidden",
    },
    modalHeader: {
        maxHeight: 24,
        display: "flex",
        flex: 1,
        backgroundColor: "#d2dcdd",
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 16,
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        paddingLeft: 13,
        alignItems: "center"
    },
    productInput: {
        width: 452,
        height: 27,
        "& > div": {
            height: 27,
            border: "1px solid #979797",
            borderRadius: 3
        },
        "& fieldset": {
            display: "none"
        },
        "& div": {
            color: "#242424",
            fontFamily: "Proxima Nova",
            fontSize: "14px",
            letterSpacing: 0,
            backgroundColor: "white",
            lineHeight: "17px"
        },
        "& div:focus": {
            backgroundColor: "white !important",
        }
    },
    productSelectStyle: {
        padding: 0,
        paddingLeft: 10
    },
    menuItemRoot: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        lineHeight: "17px"
    },
    menuItemSelected: {
        backgroundColor: "#f3fdfd !important"
    },
    modalContentWrapper: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        paddingLeft: 17,
        paddingRight: 17,
        paddingBottom: 17,
    },
    productSelectWrapper: {
        display: "flex",
        marginTop: 22,
        alignItems: "center"
    },
    productText: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        lineHeight: "17px",
        width: 80,
        fontWeight: "bold",
    },
    menuItemWidth: {
        minWidth: 452,
        maxWidth: 452
    },
    menuItemList: {
        "& li": {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "inline-block",
            width: "100%"
        }
    },
    statusStyle: {
        paddingRight: 20
    },
    errorWrapper: {
        color: "#E12929",
        fontFamily: "Proxima Nova",
        fontSize: "12px",
        letterSpacing: 0,
        lineHeight: "15px",
        minHeight: 16,
        marginLeft: 80,
        marginTop: 3
    },
    qtyWrapper: {
        marginTop: 16,
        display: "flex",
        alignItems: "center"
    },
    qtyNumberField: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        backgroundColor: "white",
        lineHeight: "17px",
        width: 40,
        height: 23,
        border: "1px solid #979797",
        borderRadius: 5,
        textAlign: "center",
        outline: "none"
    },
    reasonForChangeWrapper: {
        marginTop: 37
    },
    reasonForChangeText: {
        width: "auto !important"
    },
    reasonForChangeTextArea: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        backgroundColor: "white",
        lineHeight: "17px",
        width: "100%",
        height: 120,
        border: "1px solid #979797",
        borderRadius: 5,
        resize: "none",
        marginTop: 3,
        boxSizing: "border-box",
        outline: "none",
        padding: 10
    },
    buttonStyle: {
        boxShadow: 'none',
        width: 150,
        height: 30,
        textTransform: 'none',
        fontSize: 16,
        lineHeight: "20px",
        padding: 0,
        marginRight: 20,
        fontWeight: "bold",
        backgroundColor: '#00ad50',
        fontFamily: "Proxima Nova",
        '&:hover': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:disabled': {
            color: 'white',
            boxShadow: 'none',
        },
    },
    cancelButtonStyle: {
        boxShadow: 'none',
        width: 108,
        height: 30,
        textTransform: 'none',
        fontSize: 16,
        lineHeight: "20px",
        padding: 0,
        border: "1px solid #4d4d4d",
        color: "#242424",
        fontWeight: "bold",
        backgroundColor: 'white',
        fontFamily: "Proxima Nova",
        '&:hover': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
    },
    modalActionWrapper: {
        display: "flex",
        flex: 1,
        justifyContent: "flex-end",
        alignItems: "flex-end"
    },
    qtySelect: {
        width: 80,
        height: 27,
        "& > div": {
            height: 27,
            border: "1px solid #979797",
            borderRadius: 3
        },
        "& fieldset": {
            display: "none"
        },
        "& div": {
            color: "#242424",
            fontFamily: "Proxima Nova",
            fontSize: "14px",
            letterSpacing: 0,
            backgroundColor: "white",
            lineHeight: "17px"
        },
        "& div:focus": {
            backgroundColor: "white !important",
        }
    },
    qtyMenuItemWidth: {
        minWidth: 80,
        maxWidth: 80
    },
    redRow: {
        color: "#FF0000 !important"
    },
    consultationQuestionRow: {
        color: "#242424",
        padding: "0px 20px",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        letterSpacing: 0,
        lineHeight: "17px",
        width: "70%"
    },
    noConsultData: {
        color: "#242424",
        padding: "0px 20px",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        letterSpacing: 0,
        lineHeight: "17px",
        marginTop: 16,
    },
    consultationAnswerRow: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        letterSpacing: 0,
        lineHeight: "17px",
        width: "30%"
    },
    doseSpotWarning: {
        position: "absolute",
        left: -32,
        top: 8,
        color: "#F7A40F",
        cursor: "pointer"
    },
    patientIconText: {
        color: "#2e2e2e",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        margin: "5px",
        lineHeight: "initial",
        borderBottom: "1px solid",
        cursor: "pointer"
    },
    patientIcon: {
        display: "flex",
        justifyContent: "space-between",
        lineHeight: "37px",
        margin: "10px",
        cursor: "pointer"
    },
    dummyVisitButton: {
        width: 170,
        minWidth: 170
    },
    ButtonWrapper: {
        display: "flex"
    },
    doneIcon: {
        position: "absolute",
        height: 36,
        width: 36,
        right: 5,
        color: "#00AD50 !important"
    },
    lastDoneIcon: {
        right: "-10px !important",
    }
})

export default MainPageStyle;